<template>
  <div>
    <div
      v-if="!isElementLoading && renderElement(element, tabIdx, rowIdx, colIdx)"
    >
      <div
        class="form-builder-elements"
        :class="{ 'edit-mode': isEditable }"
        :id="idx"
        @click="onElementEdit(element)"
        @dragover="isEditable && $emit('dragover', $event, idx)"
      >
        <div
          class="form-builder-element-wrap"
          :class="{
            'workBuilder-element-width': !isFullWidth,
            'drop-zone top':
              activeDropZone < draggedElementIdx &&
              idx == activeDropZone &&
              isEditable,
            'drop-zone bottom':
              activeDropZone > draggedElementIdx &&
              idx == activeDropZone &&
              isEditable,
            'full-width': element.type === 'freecontent' && !isEditable,
          }"
          @dragstart="$emit('drag', $event, idx)"
          @dragend="isEditable && $emit('drop', $event)"
          :draggable="isElementDragabble(element)"
          @mouseleave="onMouseLeaveFromTools"
        >
          <ul
            class="edit-mode-tools"
            v-if="isUserHasAccess && isEditable && !isSheetDatabaseType"
          >
            <li>
              <i
                class="far fa-trash-alt me-1"
                @click="
                  ($event) => {
                    $event.stopPropagation();
                    $emit('removeElement', element);
                  }
                "
              ></i>
            </li>
            <li v-if="element.type !== 'resultwindow'">
              <i
                class="far fa-clone"
                @click="
                  ($event) => {
                    $event.stopPropagation();
                    $emit('duplicateElement', element, idx);
                  }
                "
              ></i>
            </li>
            <li>
              <generalDropdown
                :isCaretVisible="false"
                class="task-tools-more-dropdown"
                ref="taskToolsMoreDropdown"
                uniqueReferenceId="insertNewElementDropdown"
              >
                <template v-slot:iconContainer>
                  <i
                    class="fas fa-ellipsis-h ellipsis-icon"
                    @click="$emit('onElementMoreIconClick')"
                  ></i
                ></template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    @click.stop="$emit('insertNewElement', idx, 'top')"
                    >oben einfügen
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click.stop="$emit('insertNewElement', idx, 'bottom')"
                    >unten einfügen</b-dropdown-item
                  >
                </template>
              </generalDropdown>
            </li>
          </ul>
          <div
            class="form-builder-element-attributes"
            :class="{
              'ai-model-active':
                element.type !== 'objectlist' && isAskAiUiModalVisible,
              active: isActivePropsElement,
              'cursor-pointer': !isAskAiUiModalVisible,
            }"
            @click="elementOnclick"
          >
            <div class="input-attribute">
              <label
                class="element-label"
                :class="element.name"
                :for="element.label"
                :id="`label-${element.id}`"
                v-if="elementNeedsLabel(element)"
              >
                <i
                  v-if="['html', 'automatedaicss'].includes(element.type)"
                  class="fa fa-palette"
                  style="margin-right: 10px"
                ></i>
                <span :style="element.customStyle && element.customStyle.label"
                  >{{ element.label
                  }}<span
                    v-if="isAddingNewItem && element.attributes.required"
                    class="required-tick"
                    >*</span
                  ></span
                >
              </label>
              <input
                @keydown="preventInputKeyDown($event, element.type)"
                class="form-input"
                :id="`input-${element.id}`"
                v-if="elementNeedsInput(element)"
                :required="isRequired(element.attributes)"
                :disabled="isReadOnly"
                :placeholder="getPlaceholder(element)"
                :type="element.type"
                :name="element.name"
                :class="{
                  [element.name]: true,
                  highlighted: isEmptyFileInput(element.label),
                  'prevent-pointer-event':
                    !isAddingNewItem && !isAskAiUiModalVisible,
                  'cursor-pointer': !isAddingNewItem && isAskAiUiModalVisible,
                }"
                v-model="element.value"
                :style="element.customStyle && element.customStyle.style"
                :pattern="getPattern"
                @input="addValidationMessage"
                @invalid="handleInputValidation"
              />
              <input
                @keydown="preventInputKeyDown"
                class="form-input"
                :id="`input-${element.id}`"
                :key="`input-${element.id}`"
                v-if="element.type === 'file'"
                :required="isRequired(element.attributes)"
                :disabled="isReadOnly"
                :placeholder="getPlaceholder(element)"
                :type="element.type"
                :name="element.name"
                :class="{
                  [element.name]: true,
                  highlighted: isEmptyFileInput(element.label),
                  card: hasCardAppearance(element),
                  oval: hasOvalAppearance(element),
                  'prevent-pointer-event':
                    !isAddingNewItem && !isAskAiUiModalVisible,
                  'cursor-pointer': !isAddingNewItem && isAskAiUiModalVisible,
                }"
                :pattern="getPattern"
              />

              <div class="range-slider-values" v-if="element.type === 'range'">
                <div class="min-value" :id="`div-min-${element.id}`">
                  {{ formatWithThousandSeparator(element.attributes.min) }}
                </div>
                <div class="max-value" :id="`div-max-${element.id}`">
                  {{ formatWithThousandSeparator(element.attributes.max) }}
                </div>
              </div>
              <input
                class="form-input"
                :class="{
                  'prevent-pointer-event':
                    !isAddingNewItem && !isAskAiUiModalVisible,
                  'cursor-pointer': !isAddingNewItem && isAskAiUiModalVisible,

                  [element.name]: true,
                  'range-input ': element.type === 'range',
                  'custom-range-input ': element.type === 'range',
                }"
                v-if="['number', 'range', 'timestampms'].includes(element.type)"
                :id="`input-${element.id}`"
                :required="isRequired(element.attributes)"
                :disabled="isReadOnly"
                :placeholder="getPlaceholder(element)"
                :type="element.type === 'timestampms' ? 'number' : element.type"
                :name="element.name"
                v-model.number="element.value"
                :step="element.attributes.step"
                :min="element.attributes.min"
                :max="element.attributes.max"
                :style="element.customStyle && element.customStyle.style"
                @mousedown="onRangeInputMousedown"
                @keydown="preventInputKeyDown($event, element.type)"
                :ref="element.type === 'range' && `rangeInput${element.id}`"
                @input="handleInputValidation"
                @invalid="handleInputValidation"
              />
              <output
                v-if="element.type === 'range'"
                :id="`output-${element.id}`"
                class="range-output-value"
                :ref="`rangeoutput${element.id}`"
                >{{
                  formatWithThousandSeparator(getSliderElementValue)
                }}</output
              >

              <number-component
                v-if="element.type === 'formatted_number'"
                :editableComponent="true"
                :styleClass="element.name"
                :decimalValuesCount="element?.settings?.toFixed"
                :formatNumber="getFormatNumber"
                :passedNumberValue="element.value"
                :disabledInput="!isContentEditable || isAddOnly"
                @onNumberInputChange="onNumberComponentInputChange"
                :requiredInput="isRequired(element.attributes)"
                :componentPlaceholder="getPlaceholder(element)"
                :name="element.name"
                :maxValue="Number(element.attributes.max) || Infinity"
                :minValue="Number(element.attributes.min) || -Infinity"
                @toggleValidationError="toggleErrorInForm"
                :showAsFixedNumber="this.isEditable"
                :aiInlineCss="element.customStyle && element.customStyle.style"
                :class="{
                  'prevent-pointer-event':
                    !isAddingNewItem && !isAskAiUiModalVisible,
                  'cursor-pointer': !isAddingNewItem && isAskAiUiModalVisible,
                }"
                :elementId="element.id.toString()"
              />

              <!-- File Picker  Start -->
              <div
                class="edit-item-name"
                :class="{
                  [element.name]: true,
                  'update-select-file':
                    element.type === 'filenew' &&
                    !element.value &&
                    isAddingNewItem,
                }"
                v-if="element.type === 'filenew'"
              >
                <FilePicker
                  @onFileSelected="onFileSelected($event, element)"
                  @onFileDelete="onFileDelete(element)"
                  :ref="`filePickerRef${element.id}`"
                  :uniqueId="`filePicker${element.id}`"
                  :isAllowedToAddFile="isAddingNewItem"
                  :isActionsButtonEnable="isAddingNewItem"
                  :isAddOnly="isAddOnly"
                  :isDownloadButtonVisible="true"
                  :value="element.value"
                  :selectedDatabase="selectedDatabase"
                  :aiInlineCss="
                    element.customStyle && element.customStyle.style
                  "
                  :isAskAiUiModalVisible="isAskAiUiModalVisible"
                />
              </div>
              <!-- File Picker End -->

              <!-- sheet input start -->
              <div class="edit-item-name" v-if="element.type === 'sheet'">
                <input
                  class="form-input"
                  type="text"
                  :value="getStringifySheetObject(element.value)"
                  :style="element.customStyle && element.customStyle.style"
                  @keydown.prevent
                />
              </div>
              <!-- sheet input end -->

              <!-- Smart Message or Text area -->
              <div class="html-view-switch" v-if="isShowTextAreaHtmlViewSwitch">
                <CommonSwitch
                  v-if="isShowTextAreaHtmlViewSwitch"
                  class="common-switch"
                  v-model="isShowHtmlView"
                ></CommonSwitch>
                <span>HTML View</span>
              </div>
              <div
                class="textarea-html-render"
                v-if="isShowTextAreaHtmlViewSwitch && isShowHtmlView"
                v-html="element.value"
              ></div>
              <textarea
                v-if="
                  ['smartmessage', 'textarea'].includes(element.type) &&
                  !(isShowTextAreaHtmlViewSwitch && isShowHtmlView)
                "
                :id="`textarea-${element.id}`"
                :disabled="isReadOnly"
                :name="element.name"
                :required="element.attributes.required"
                v-model="element.value"
                class="form-textarea"
                :class="{
                  'prevent-pointer-event':
                    !isAddingNewItem && !isAskAiUiModalVisible,
                  'cursor-pointer': !isAddingNewItem && isAskAiUiModalVisible,
                  [element.name]: true,
                }"
                :style="element.customStyle && element.customStyle.style"
                @input="handleInputValidation"
                @invalid="handleInputValidation"
              ></textarea>
              <!-- :class="element.name" -->

              <div
                v-if="element.type === 'html' && !isEditable"
                :class="element.name"
                v-html="element.value"
              ></div>
            </div>
            <!-- Togglelist start -->
            <p
              class="togglelist-label"
              :id="`togglelist-${element.id}`"
              v-if="
                element.type == 'togglelist' &&
                element.name.includes('start') &&
                isEditable
              "
              :style="element.customStyle && element.customStyle.style"
            >
              Elemente unterhalb dieses Textes werden in der Klappliste
              angezeigt.
            </p>
            <p
              class="togglelist-label"
              v-if="
                element.type == 'togglelist' &&
                element.name.includes('end') &&
                isEditable
              "
              :style="element.customStyle && element.customStyle.style"
            >
              Elemente unterhalb dieses Textes werden nicht mehr in der
              Klappliste angezeigt.
            </p>
            <!-- Togglelist end -->

            <!-- linktodb start -->

            <div
              class="me-2 link-to-db-wrapper-edit"
              v-if="isLinkinView || isLinkinEdit"
            >
              <i class="fa fa-link"></i>
              <a
                :href="generateDatabaseLink()"
                :style="element.customStyle && element.customStyle.style"
                >{{ getLinkDatabseLabelValue(element) || element.name }}</a
              >
            </div>

            <div
              v-if="isLinkinAdd"
              class="me-2 link-to-db-wrapper link-to-db-dropdown"
            >
              <GeneralDropdown
                className="database-dropdown"
                @onDropdownOpen="getDropdownOptions"
              >
                <template v-slot:selectFilter>
                  <div v-if="getLinkDatabseLabelValue(element)" @click.stop>
                    <i class="fa fa-link"></i>
                    <a :href="generateDatabaseLink()" target="_blank">{{
                      getLinkDatabseLabelValue(element)
                    }}</a>
                  </div>
                  <div @click.stop v-else>Select</div>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-if="isDbItemListLoading"
                    class="loading-overlay-wrapper"
                  >
                    <div class="loading-overlay">
                      <div class="progress-icon"></div>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-for="(item, index) in databaseItemsList"
                    :key="`${item.id}-${index}`"
                    @click="onDatabaseItemChange(item)"
                    v-show="!isDbItemListLoading"
                    :class="{ selected: item.id === element.value }"
                  >
                    {{ getDropDownItemLabel(item) }}
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
            </div>

            <!-- linktodb end -->

            <!-- Wizard start -->

            <div
              class="wizard-title"
              v-if="element.type == 'title' && element.defaultTabs"
              :class="element.name"
            >
              <h3
                :id="`title-${element.id}`"
                :style="element.customStyle && element.customStyle.style"
              >
                {{ element.label }}
              </h3>
            </div>

            <!-- Wizard end -->

            <!-- Wrapper start -->
            <p
              class="togglelist-label"
              v-if="
                element.type == 'wrapper' &&
                element.name.includes('start') &&
                isEditable
              "
              :style="element.customStyle && element.customStyle.style"
            >
              Elemente unterhalb dieses Textes werden in der Wrapper
              eingewickelt.
            </p>
            <p
              class="togglelist-label"
              v-if="
                element.type == 'wrapper' &&
                element.name.includes('end') &&
                isEditable
              "
              :style="element.customStyle && element.customStyle.style"
            >
              Elemente unterhalb dieses Textes werden nicht mehr in der Wrapper
              eingewickelt.
            </p>
            <!-- Wrapper end -->

            <img
              :src="element.url"
              v-if="element.url && element.type === 'image'"
              alt="image"
              class="preview-image"
              :id="`img-${element.id}`"
              :class="element.name"
            />
            <span
              v-else-if="element.type === 'image' && element.url === ''"
              class="required-url"
              :class="element.name"
              :id="`img-input-${element.id}`"
              :style="element.customStyle && element.customStyle.style"
              >Kein Bild ausgewählt</span
            >
            <!--Adding the video file along with the image-->
            <p
              align="center"
              v-if="element.type === 'video' && element.url"
              :class="element.name"
              :style="element.customStyle && element.customStyle.style"
            >
              <video
                controls
                width="400"
                height="200"
                :id="`video-${element.id}`"
              >
                <!-- poster="https://media.geeksforgeeks.org/wp-content/uploads/20200717172614/authPreLogo.png" -->
                <source :src="element.url" type="video/mp4" />
              </video>
            </p>
            <span
              v-else-if="element.type === 'video' && element.url === ''"
              class="required-url"
              :class="element.name"
              :id="`video-input-${element.id}`"
              :style="element.customStyle && element.customStyle.style"
              >Kein Video ausgewählt</span
            >

            <Cards
              v-if="element.type == 'objectlist'"
              :schema="element.schema"
              :itemWidth="'45%'"
              :cards="element.value"
              :viewOnly="isReadOnly"
              :class="element.name"
              itemHeight="unset"
              :isAddButtonDisable="isAskAiUiModalVisible"
              :elementId="element.id"
            />

            <!-- HR -->
            <hr
              v-if="element.type == 'horizontalrule'"
              :id="`hr-${element.id}`"
              :class="element.name"
              :style="element.customStyle && element.customStyle.style"
            />

            <!-- Title -->
            <h3
              class="codelos-title"
              :id="`title-${element.id}`"
              v-if="element.type == 'title' && !element.defaultTabs"
              :class="element.name"
              :style="element.customStyle && element.customStyle.style"
            >
              {{ element.label }}
            </h3>
            <div
              class=""
              v-if="element.type == 'description'"
              :id="`description-${element.id}`"
              :class="element.name"
              :style="element.customStyle && element.customStyle.style"
            >
              {{ element.label }}
            </div>
            <div
              v-if="element.type === 'resultwindow'"
              :class="element.name"
            ></div>
            <label
              v-if="isTogglableListElement(element)"
              class="togglelist-label element-label"
              :class="element.name"
              @click="toggleTogglelist(element.id.toString())"
              :name="element.name"
              >{{ element.label }}</label
            >
            <div
              v-if="isTogglableListElement(element)"
              class="content"
              :id="element.id"
              v-show="opennedTogglelist.includes(element.id.toString())"
              :class="element.name"
            >
              <div
                class="form-group"
                v-for="(childElement, index) in element.elements"
                :key="childElement.name"
                v-show="filtertoogleListElements(childElement, element)"
                :class="{
                  large: isLargeWrapperRequired(childElement.type),
                }"
              >
                <element-renderer
                  class="form-elements nested-form-elements"
                  :element="childElement"
                  :colIdx="colIdx"
                  :renderElement="renderElement"
                  :tabIdx="tabIdx"
                  :rowIdx="rowIdx"
                  :idx="`${childElement.name}${index}`"
                  :elementCount="element.elements.length"
                  :isLargeWrapperRequired="isLargeWrapperRequired"
                  :isUserHasAccess="isUserHasAccess"
                  :isEditable="isEditable"
                  :activeDropZone="activeDropZone"
                  :isContentEditable="isContentEditable"
                  :isAddOnly="isAddOnly"
                  :isEmptyFileInput="isEmptyFileInput"
                  :isFullWidth="isFullWidth"
                  @onFileSelected="onFileSelected"
                  @onFileDelete="onFileDelete"
                  :isAddingNewItem="isAddingNewItem"
                  :hasFooter="hasFooter"
                />
              </div>
            </div>

            <div
              v-if="isNotSelectOrCardElement"
              class="radio-wrapper"
              :class="element.name"
            >
              <div
                v-for="(option, index) in element.options"
                :key="index"
                class="radioOption"
              >
                <!-- :id="element.label + option.label" -->
                <input
                  :key="element.label + option.label + Date.now()"
                  :id="`option-${index}-input-${element.id}-`"
                  :disabled="isReadOnly"
                  :type="element.type"
                  :name="element.name"
                  :value="getCheckBoxOrRadioValue(option)"
                  :checked="getOptionsValue(option.checked)"
                  @change="changeChecked(element, option)"
                  :style="element.customStyle && element.customStyle.style"
                  @keydown="preventInputKeyDown($event, element.type)"
                  :required="isInputRequired"
                />
                <label
                  :for="element.label + option.label"
                  :id="`option-${index}-label-${element.id}`"
                  >{{ option.label }}</label
                >
              </div>
              <input
                v-if="checkboxValidationRequired"
                type="text"
                :required="true"
                :value="checkboxValidation"
                class="checkBox-validation"
                @invalid="setCustomValidity"
              />
            </div>
            <div
              v-if="isChoiceWithCard(element)"
              class="radio-wrapper image-with-detail-wrap"
              :class="{
                'defualt-view ': !isBackgroundImage && !isShowDescription,
                'both-image-description-active ':
                  isBackgroundImage && isShowDescription,
                'show-background': isBackgroundImage,
                'show-description': isShowDescription,
              }"
            >
              <input
                v-if="checkboxValidationRequired"
                type="text"
                :required="true"
                :value="checkboxValidation"
                class="checkBox-validation"
                @invalid="setCustomValidity"
              />
              <div
                v-for="(option, index) in element.options"
                :key="index"
                :id="`option-card-${index}-${element.id}`"
                class="image-with-detail-section"
                :class="{
                  'image-with-detail-section-active':
                    !isEditable && getOptionsValue(option.checked),
                  'image-with-detail-section-inactive':
                    !isEditable && !getOptionsValue(option.checked),
                }"
                :style="{
                  'background-image': isBackgroundImage
                    ? `url(${option.img})`
                    : '',
                  cssText: `${
                    isBackgroundImage
                      ? 'background-image: url(' +
                        option.img +
                        '); background-size: cover;'
                      : ''
                  }${
                    element.customStyle && element.customStyle.style
                      ? element.customStyle.style
                      : ''
                  }`,
                }"
              >
                <label :for="element.label + option.label">
                  <input
                    v-if="isAddingNewItem && !isAskAiUiModalVisible"
                    :id="element.label + option.label"
                    :disabled="!isContentEditable || isAddOnly"
                    :type="element.type"
                    :value="option.label"
                    :checked="getOptionsValue(option.checked)"
                    @change="changeChecked(element, option)"
                  />
                  <label
                    class="option-label"
                    :for="element.label + option.label"
                  >
                    <div
                      class="option-image"
                      v-if="option.img && !isBackgroundImage"
                    >
                      <img
                        :id="`option-card-image-${index}-${element.id}`"
                        :src="option.img"
                        alt=""
                      />
                    </div>
                    <h1
                      :id="`option-card-label-${index}-${element.id}`"
                      v-if="isBackgroundImage || isShowDescription"
                    >
                      {{ option.label }}
                    </h1>
                    <div
                      v-else
                      class="title"
                      :id="`option-card-label-${index}-${element.id}`"
                    >
                      <span
                        :style="
                          element.customStyle && element.customStyle.style
                        "
                        >{{ option.label }}</span
                      >
                    </div>
                    <div
                      class="detail"
                      :id="`option-card-description-${index}-${element.id}`"
                      v-if="isShowDescription && option.description"
                    >
                      {{ option.description }}
                    </div>
                  </label>
                </label>
              </div>
            </div>
            <GeneralDropdown
              className="database-dropdown display-dropdown"
              :disabled="!isReadOnly && isEditable"
              v-if="element.type == 'select'"
              :name="element.name"
              :dropdownId="`dropdown-${element.id}`"
              :class="element.name"
            >
              <span :style="element.customStyle && element.customStyle.label">{{
                element.label
              }}</span>
              <template v-slot:selectFilter>
                <span
                  :style="element.customStyle && element.customStyle.style"
                  >{{ isSelectedOptionLabel }}</span
                >
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="(option, index) in element.options"
                  :key="index"
                  @click="changeChecked(element, option)"
                >
                  {{ option.label }}
                </b-dropdown-item>
              </template>
            </GeneralDropdown>
            <!-- page component started -->

            <div
              v-if="element.type === 'freecontent'"
              :id="element.name"
              :class="element.name"
              @click="onClickFreeContentElement"
              @mousedown="onMouseClickInPageEditor"
              @mouseleave="onMouseLeaveFromPageEditor"
            >
              <PageEditor
                :element="element"
                :isFullScreenToggle="!isCreateCustomDB"
              />
            </div>

            <!-- page component ended -->

            <!-- database linked view started -->

            <div
              v-if="element.type === 'databaselinkedview'"
              class="database-linked-view database-linked-view-add"
            >
              <CustomDatabaseInline
                :element="element"
                :elements="elements"
                :isAddingNewItem="isAddingNewItem"
                :isDatabaseLinkedViewinAdd="isDatabaseLinkedViewinAdd"
                ref="customDatabaseInline"
              />

              <!-- <table
                v-if="
                  isDatabaseLinkedViewinAdd &&
                  databaseLinkedViewData &&
                  databaseLinkedViewData.length
                "
              >
                <tr>
                  <th
                    v-for="(item, index) in getDatabaseLinkedViewDataHeaders"
                    :key="`db-header-item-${index}`"
                  >
                    {{ item }}
                  </th>
                  <th>Tools</th>
                </tr>
                <tr
                  v-for="(row, index) in databaseLinkedViewData"
                  :key="`db-item-rows-${index}`"
                >
                  <td
                    v-for="(item, index) in getDatabaseLinkedViewDataHeaders"
                    :key="`db-item-${index}`"
                  >
                    {{ row[item] }}
                  </td>
                  <td
                    class="tools-action-wrapper d-flex gap-2 justify-content-center align-items-center border-0"
                  >
                    <i
                      @click="onEditDatabaseLinkedViewData(row)"
                      class="fas fa-edit cursor-pointer"
                    ></i>
                    <i
                      @click="onDeleteDatabaseLinkedViewData"
                      class="fas fa-trash cursor-pointer"
                    ></i>
                  </td>
                </tr>
              </table> -->
            </div>

            <!-- database linked view ended -->

            <!-- div wrapper -->

            <div
              v-if="isDivWrapperElement(element)"
              class="codelos-wrapper"
              :class="element.name.replace('-start', '')"
              :id="element.id"
            >
              <div
                class="form-group"
                v-for="(childElement, index) in element.elements"
                :key="childElement.name"
                v-show="
                  (childElement.type != 'html' &&
                    childElement.type != 'model') ||
                  isAdmin
                "
                :class="{
                  large: isLargeWrapperRequired(childElement.type),
                }"
              >
                <element-renderer
                  class="form-elements nested-form-elements"
                  :element="childElement"
                  :colIdx="colIdx"
                  :renderElement="renderElement"
                  :tabIdx="tabIdx"
                  :rowIdx="rowIdx"
                  :idx="`${childElement.name}${index}`"
                  :elementCount="element.elements.length"
                  :isLargeWrapperRequired="isLargeWrapperRequired"
                  :isUserHasAccess="isUserHasAccess"
                  :isEditable="isEditable"
                  :activeDropZone="activeDropZone"
                  :isContentEditable="isContentEditable"
                  :isEmptyFileInput="isEmptyFileInput"
                  :isFullWidth="isFullWidth"
                  @onFileSelected="onFileSelected"
                  @onFileDelete="onFileDelete"
                  :isAddingNewItem="isAddingNewItem"
                  :hasFooter="hasFooter"
                />
              </div>
            </div>
            <div
              v-if="
                element.type === 'html' &&
                element?.settings?.isHtmlRendered &&
                getSanitizedContent()?.length &&
                isEditable
              "
              class="html-render"
            >
              <div
                v-html="getSanitizedContent()"
                :contenteditable="true"
                @input="changeHtmlContent"
                @focus="onHtmlPreviewFocus"
                @blur="onHtmlPreviewBlur"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <b-dropdown
        id="dropdown-dropleft"
        class="form-builder-element-attributes-label"
        ref="chatGptDropDown"
        v-if="isAskAiUiModalVisible"
        @hide="handleCloseAiPopup"
        @show="handleShowAiPopup"
      >
        <b-dropdown-group @click.stop class="ai-dropdown-wrap">
          <div class="">
            <input
              type="text"
              placeholder="Make the text larger, add a title or change the colors of this variation"
              ref="chatgptInputRef"
              v-model="chatGptApiInput"
              @keydown.stop="onGenerateAutomatedCSSKeydown"
            />
            <span class="error">{{ chatGptApiError }}</span>
          </div>
          <button
            class="submit-btn"
            @click.stop="generateAutomatedAICSS"
            :disabled="isChatGptApiLoader"
          >
            <span v-if="!isChatGptApiLoader">Senden</span>
            <div
              class="custom-table-progress-icon"
              v-if="isChatGptApiLoader"
            ></div>
          </button>
        </b-dropdown-group>
      </b-dropdown>
    </div>
    <TableSkeleton
      class="skeleton-wrapper"
      :numberOfRow="1"
      v-if="isElementLoading"
      :isLoading="isElementLoading"
    ></TableSkeleton>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FilePicker from '../core/FilePicker.vue';
import GeneralDropdown from '../core/general-dropdown.vue';
import { getTableItems } from '../../services/userTable';
import NumberComponent from './NumberComponent.vue';
import PageEditor from './PageEditor.vue';
import { getCustomDatabaseItems } from '../../services/customdb.service';
import { getDataBaseTableSchema } from '../../services/userTable';
import { askChatGPT } from '@/services/workflow.service';
import CustomDatabaseInline from '../CustomDatabase/CustomDatabaseInline.vue';
import TableSkeleton from '../../components/widgets/TableSkeleton.vue';
import CommonSwitch from '../../components/widgets/CommonSwitch.vue';

import {
  getApiEndpointVersion,
  getSliderValuePosition,
  getCheckboxMinMax,
  formatWithThousandSeparator,
} from '@/utils/helpers';

import moment from 'moment';
import { showInputInvalidCustomMessage } from '../../utils/helpers';
export default {
  name: 'element-renderer',
  data() {
    return {
      chatGptApiInput: '',
      chatGptApiError: null,
      opennedTogglelist: [],
      databaseItemsList: [],
      isDbItemListLoading: false,
      isPageEditorDraggeble: true,
      databaseLinkedViewData: [],
      automatedAiTargetedElement: null,
      preFilledRadio: [],
      htmlContent: '<div></div>',
      isFocusedOnHtmlPreview: false,
      showcaseField: null,
      isElementLoading: false,
      previousHoveredEl: null,
      isShowHtmlView: false,
    };
  },
  props: {
    flowRunnerEndpoint: {
      type: String,
      required: false,
      default: process.env.VUE_APP_FLOW_RUNNER_API,
    },
    isAskAiUiModalVisible: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      required: true,
    },
    isContentEditable: {
      type: Boolean,
      required: true,
    },
    isUserHasAccess: {
      type: Boolean,
      required: true,
    },
    element: {
      type: Object,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    tabIdx: {
      type: Number,
      required: true,
    },
    rowIdx: {
      type: Number,
      required: true,
    },
    colIdx: {
      type: Number,
      required: true,
    },
    idx: {
      type: [Number, String],
      required: true,
    },
    draggedElementIdx: {
      type: Number,
      default: null,
    },
    elementCount: {
      type: Number,
      required: true,
    },

    activeDropZone: {
      type: String,
    },
    isLargeWrapperRequired: {
      type: Function,
      required: true,
    },

    isEmptyFileInput: {
      type: Function,
      required: true,
    },
    isAddingNewItem: {
      type: Boolean,
      default: false,
    },
    isFullWidth: {
      type: Boolean,
      required: true,
    },
    selectedDatabase: {
      type: Object,
      default: () => null,
    },
    isAddOnly: {
      type: Boolean,
      default: false,
    },
    isCreateCustomDB: {
      type: Boolean,
      default: false,
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
    isChatGptApiLoader: {
      type: Boolean,
      default: false,
    },
    selectedElement: {
      type: Object,
      default: () => null,
    },
    isPropsModalVisible: {
      type: Boolean,
      default: false,
    },
    createdValue: {
      type: Number | String,
      required: false,
      default: null,
    },
    search: {
      type: String,
      required: false,
      default: null,
    },
  },
  // created() {
  // this.getDatabaseLinkedViewData();
  // },
  async mounted() {
    if (this.element.type === 'radio') {
      if (this.isRadioButtonNotPrefilled) {
        this.preFilledRadio.push(this.element.id);
      }
      const selectedElement = this.element.options.find(
        (option) => option.checked
      );
      if (
        selectedElement &&
        this.element.value !== null &&
        this.createdValue === null
      ) {
        this.element.value = selectedElement.hasOwnProperty('value')
          ? selectedElement.value
          : selectedElement.label;
      }
    }
    if (this.element.type === 'checkbox') {
      const selectedOptions = this.element.options
        .filter((option) => option.checked)
        .map((option) =>
          option.hasOwnProperty('value') ? option.value : option.label
        );
      if (this.createdValue === null) {
        this.element.value = selectedOptions;
      }
    }

    if (this.element.type === 'range') {
      this.element.value = this.getSliderElementValue;
    }

    if (this.element.type === 'html') {
      if (this.element?.settings?.isHtmlRendered === undefined) {
        this.element.settings = {
          ...this.element.settings,
          isHtmlRendered: false,
        };
      }
      this.htmlContent = this.element.value;
    }

    if (
      (this.element.type === 'date' ||
        this.element.type === 'datetime-local') &&
      this.element?.attributes?.todayAsDefaultValue &&
      this.element?.settings?.default &&
      this.createdValue === null &&
      this.isAddingNewItem
    ) {
      this.element.value =
        this.element.type === 'date'
          ? moment().format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DDTHH:mm');
    }
    for (const element of this.elements) {
      if (this.element?.settings?.showcaseField === undefined) {
        this.element.settings = {
          ...this.element.settings,
          showcaseField: false,
        };
      }
    }
    if (this.element.type === 'linktodb') {
      this.isElementLoading = true;
      await this.getDropdownOptions();
      this.isElementLoading = false;
    }

    if (this.element.type === 'textarea' && this.isShowTextAreaHtmlViewSwitch) {
      this.isShowHtmlView = true;
    }
    if (!this.isAddingNewItem) {
      document.addEventListener('pointerover', this.handlePointerOver);
    }
  },
  beforeDestroy() {
    document.removeEventListener('pointerover', this.handlePointerOver);
  },
  methods: {
    preventInputKeyDown(e, elementType) {
      if (!this.isAddingNewItem) {
        e.preventDefault();
      }
      if (elementType === 'number') {
        const selection = window.getSelection();
        if (
          !selection.toString().length &&
          e.target.value?.length >= 38 &&
          /[0-9]/.test(e.key)
        ) {
          e.preventDefault();
        }
      }
    },
    removeDuplicateStyles(style) {
      let styleArray = style.split(';');
      const styleObject = {};
      styleArray.forEach((style) => {
        if (style.trim() !== '') {
          const [key, value] = style.split(':');
          styleObject[key.trim()] = value.trim();
        }
      });
      return Object.entries(styleObject)
        .map(([key, value]) => `${key}: ${value}`)
        .join(';');
    },
    handleCloseAiPopup(event) {
      if (this.isChatGptApiLoader) {
        event.preventDefault();
      } else {
        if (this.automatedAiTargetedElement) {
          this.automatedAiTargetedElement.classList.remove('ai-target-element');
        }
        this.$emit('toggleAiDropdown', this.element.id);
      }
    },
    handleShowAiPopup() {
      this.$emit('toggleAiDropdown', this.element.id);
    },
    closeAiPopup() {
      if (this.isChatGptApiLoader) return;
      this.$refs.chatGptDropDown.hide();
      this.chatGptApiInput = '';
      this.chatGptApiError = null;
    },
    isElementContainsClass(element, elementClass) {
      return element && element.classList.contains(elementClass);
    },
    getTargetedElement(event) {
      const currentElement = event?.target;
      if (!currentElement) return null;

      let targetElement = null;

      if (
        currentElement.tagName === 'SPAN' &&
        this.isElementContainsClass(
          currentElement.parentElement,
          'element-label'
        )
      ) {
        targetElement = currentElement.parentElement;
      } else if (['radio', 'checkbox'].includes(this.element.type)) {
        if (
          currentElement.tagName === 'SPAN' &&
          this.isElementContainsClass(currentElement.parentElement, 'title')
        ) {
          targetElement = currentElement.parentElement;
        } else if (
          currentElement.tagName === 'LABEL' &&
          (this.isElementContainsClass(
            currentElement.parentElement,
            'image-with-detail-section'
          ) ||
            this.isElementContainsClass(
              currentElement.parentElement,
              'option-label'
            ))
        ) {
          targetElement = currentElement.parentElement;
        } else if (
          currentElement.tagName === 'DIV' &&
          this.isElementContainsClass(currentElement, 'option-image') &&
          currentElement.firstChild
        ) {
          targetElement = currentElement.firstChild;
        } else if (
          this.isElementContainsClass(currentElement, 'option-label') &&
          currentElement?.parentElement?.tagName === 'LABEL' &&
          currentElement?.parentElement?.parentElement
        ) {
          targetElement = currentElement.parentElement.parentElement;
        } else {
          targetElement = currentElement;
        }
      } else {
        targetElement = currentElement;
      }
      return targetElement;
    },
    elementOnclick(event) {
      if (!this.isAddingNewItem) {
        event.preventDefault();
        if (this.isAskAiUiModalVisible && !this.isChatGptApiLoader) {
          this.chatGptApiInput = '';
          this.chatGptApiError = null;
          const targetElement = this.getTargetedElement(event);
          if (this.$refs.chatGptDropDown.visible) {
            this.$refs.chatGptDropDown.hide();
            if (
              this.automatedAiTargetedElement &&
              targetElement?.id &&
              targetElement !== this.automatedAiTargetedElement
            ) {
              this.automatedAiTargetedElement.classList.remove(
                'ai-target-element'
              );
              this.automatedAiTargetedElement = null;
              setTimeout(() => {
                this.elementOnclick(event);
              });
            }
          } else {
            if (targetElement?.id) {
              targetElement.classList.add('ai-target-element');
              this.$refs.chatGptDropDown.show();
              setTimeout(() => {
                this.$refs.chatgptInputRef.focus();
                this.$nextTick(() => {
                  this.$refs.chatgptInputRef &&
                    this.$refs.chatgptInputRef.focus();
                });
              });
            }
            this.automatedAiTargetedElement = targetElement;
          }
        }
      }
    },
    onGenerateAutomatedCSSKeydown(event) {
      if (event.code === 'Enter' && !this.isChatGptApiLoader) {
        this.generateAutomatedAICSS();
        event.preventDefault();
      }
    },
    async generateAutomatedAICSS() {
      try {
        if (this.isChatGptApiLoader || !this.automatedAiTargetedElement?.id)
          return;
        this.$emit('setChatGptApiLoader', true);
        this.chatGptApiError = '';
        const automatedaicssElement = this.elements.find(
          (element) => element.type === 'automatedaicss'
        );
        const errorMessage =
          'Please ask style-related questions for available elements';
        if (!this.chatGptApiInput) return;

        const url = this.flowRunnerEndpoint;

        const prompt = `As a CSS code generator assistant, you must adhere to given conditions and provide no extra responses. First, you will read the provided question and provide css for the given elementId ${
          this.automatedAiTargetedElement.id
        }. you will Respond with only the css code with #codelosForm prefix (because all element wrapper in form with id is codelosForm) for requested element without explanation. Otherwise, if you didn't get anything or not able to understand or question is not regarding css then respond with the message "${errorMessage}" wihtout including anything in this string no extra response needed.
 here is my current css code: "${
   automatedaicssElement
     ? automatedaicssElement.value.replace(
         /<style[^>]*>([\s\S]*?)<\/style>/gi,
         '$1'
       )
     : ''
 }", use the current provided styles and return whole code as updated (only update the style of given element id, please don't update other elements except the provided element id and return the whole code) without a single extra word or character or symbols or backticks at starting and ending.
        question:"${this.chatGptApiInput}".`;

        let responseMessage;
        if (getApiEndpointVersion(url) >= 6) {
          const formData = new FormData();
          formData.append(
            'props',
            JSON.stringify({
              prompt,
              model: 'gpt-4',
            })
          );
          const response = await askChatGPT(url, formData);
          responseMessage = response.data.message;
        } else {
          const response = await askChatGPT(url, {
            prompt,
          });
          responseMessage = response.data.message;
        }
        let sanitizedMessage = responseMessage;
        const patternToRemoveFromResponse =
          /^```(?:css)?([\s\S]*?)```$|^"([\s\S]*)"$/;
        if (patternToRemoveFromResponse.test(responseMessage)) {
          sanitizedMessage = responseMessage.replace(
            patternToRemoveFromResponse,
            '$1$2'
          );
        }

        if (!sanitizedMessage.startsWith('Please')) {
          this.$emit('addUiInUiElement', sanitizedMessage);
          this.chatGptApiInput = '';
        } else {
          throw new Error(sanitizedMessage);
        }
      } catch (error) {
        this.chatGptApiError = error.message.startsWith('Please')
          ? error.message
          : 'CSS kann nicht generiert werden';
      } finally {
        this.$emit('setChatGptApiLoader', false);
      }
    },
    generateDatabaseLink() {
      const domain = window.location.origin;
      const url = `${domain}/#/?section=data&database=${this.element.selectedDatabaseID}&item=${this.element.value}`;
      return url;
    },

    generateDatabaseLinkendViewURL() {
      const domain = window.location.origin;
      const url = `${domain}/#/?section=data&database=${this.element.selectedDatabaseID}&item=${this.element.value}`;
      return url;
    },
    onDatabaseItemChange(dbItem) {
      this.element.value = dbItem.id;
    },
    async getDropdownOptions() {
      if (this.databaseItemsList.length === 0) {
        try {
          this.isDbItemListLoading = true;
          const findDatabase = this.getDatabaseList.find(
            (database) => database.name === this.element.selectedDatabaseID
          );
          let schema;
          let params = '';
          if (findDatabase && findDatabase.schema) {
            schema = JSON.parse(findDatabase.schema);
          } else {
            const response = await getDataBaseTableSchema(
              this.element.selectedDatabaseID,
              true
            );
            if (response && response.status === 200 && response.data) {
              this.$store.commit('SET_DATABASE_SCHEMA', response.data);
              schema = JSON.parse(response.data.data);
            }
          }
          const findShowcaseField = schema.find(
            (el) => el?.settings?.showcaseField
          );
          if (findShowcaseField) {
            this.showcaseField = findShowcaseField;
            params = '?keys=' + findShowcaseField.name;
          }
          const listItems = await getCustomDatabaseItems(
            this.element.selectedDatabaseID,
            params,
            true
          );
          if (listItems && listItems.status === 200 && listItems.data) {
            if (this.element.selectedDatabaseType === 'loadprofile') {
              const filteredData = [...listItems.data.items].filter(
                (el) => el.id.includes('sheet') && el.ts_type === 'loadcurve'
              );
              this.databaseItemsList = filteredData;
            } else {
              this.databaseItemsList = listItems.data.items;
            }
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log({ error });
        } finally {
          this.isDbItemListLoading = false;
        }
      }
    },

    isElementDragabble(element) {
      if (this.isEditable) {
        return element.type !== 'freecontent'
          ? !element.isWizardTemplate
          : this.isPageEditorDraggeble;
      }
      return false;
    },
    renderElement(el, tabIdx, rowIdx, colIdx) {
      // Do not render frontend keys
      const excludeFromRendering = ['id', 'created', 'updated'];
      if (excludeFromRendering.includes(el.name)) return false;

      const e = el.structure,
        isTab = e.tab == tabIdx,
        isRow = e.row == rowIdx,
        isCol = e.col == colIdx;
      if ((isTab, isRow, isCol)) return true;
      else return false;
    },
    elementNeedsInput(element) {
      const withoutInput = [
        'number',
        'formatted_number',
        'range',
        'radio',
        'checkbox',
        'textarea',
        'html',
        'togglelist',
        'title',
        'description',
        'horizontalrule',
        'objectlist',
        'image',
        'video',
        'smartmessage',
        'filenew',
        'wrapper',
        'sheet',
        'linktodb',
        'freecontent',
        'timestampms',
        'select',
        'databaselinkedview',
        'automatedaicss',
        'file',
        'resultwindow',
      ];
      if (withoutInput.includes(element.type)) return false;
      return true;
    },
    elementNeedsLabel(element) {
      const withoutLabel = [
        'title',
        'horizontalrule',
        'description',
        'togglelist',
        'image',
        'video',
        'wrapper',
      ];
      if (
        withoutLabel.includes(element.type) ||
        (element.type == 'html' && !this.isEditable)
      )
        return false;
      return true;
    },
    hasCardAppearance(element) {
      if (
        element.attributes.hasOwnProperty('appearance') &&
        element.attributes.appearance == 'card'
      )
        return true;
    },
    hasOvalAppearance(element) {
      if (
        element.attributes.hasOwnProperty('appearance') &&
        element.attributes.appearance == 'oval'
      )
        return true;
    },
    isRequired(attrs) {
      if (Object.keys(attrs).includes('required'))
        return attrs.required == true;
      return false;
    },
    getPlaceholder(element) {
      if (Object.keys(element).includes('placeholder'))
        return element.placeholder;
      return null;
    },
    isChoiceWithCard(element) {
      let choiceTypes = ['radio', 'checkbox'];
      return (
        choiceTypes.includes(element.type) &&
        element.attributes.appearance === 'card'
      );
    },
    changeChecked(element, option) {
      const optionValue = option.hasOwnProperty('value')
        ? option.value
        : option.label;

      if (element.type === 'radio') {
        if (this.preFilledRadio.includes(this.element.id)) {
          this.preFilledRadio = this.preFilledRadio.filter(
            (value) => value !== this.element.id
          );
        }
        element.options.forEach((e) => {
          e.checked = false;
        });
        option.checked = true;

        element.value = optionValue;
      } else if (element.type === 'checkbox') {
        option.checked = !option.checked;
        if (option.checked) element.value.push(optionValue);
        else element.value = element.value.filter((e) => e != optionValue);
      } else if (element.type === 'select') {
        element.value = option.value;
      }
    },
    isTogglableListElement(element) {
      if (this.isEditable) return false;
      else
        return element.type == 'togglelist' && element.name.includes('start');
    },
    isDivWrapperElement(element) {
      if (this.isEditable) return false;
      else return element.type == 'wrapper' && element.name.includes('start');
    },
    toggleTogglelist(id) {
      const index = this.opennedTogglelist.findIndex(
        (togglelistId) => togglelistId == id
      );
      if (index == -1) this.opennedTogglelist.push(id);
      else this.opennedTogglelist.splice(index, 1);
    },
    onFileSelected(file, element) {
      if (this.$refs[`filePickerRef${element.id}`]) {
        this.$refs[`filePickerRef${element.id}`].setFile(file);
      }
      this.$emit('onFileSelected', file, element);
    },
    onFileDelete(element, canEmit = true) {
      if (this.$refs[`filePickerRef${element.id}`]) {
        this.$refs[`filePickerRef${element.id}`].onConfirmFileDelete(
          null,
          false
        );
      }
      if (canEmit) this.$emit('onFileDelete', element);
    },
    onFileSelectedFromElementProps(file) {
      this.$refs[`filePickerRef${this.element.id}`].setFile(file);
    },
    getStringifySheetObject(obj) {
      try {
        return !obj ? null : JSON.stringify(obj);
      } catch (err) {
        return null;
      }
    },
    showDescriptionAsList(description) {
      return description ? description.split(',') : [];
    },
    onNumberComponentInputChange(newValue) {
      this.element.value = newValue;
    },
    toggleErrorInForm(newValue) {
      this.$emit('toggleErrorInForm', newValue);
    },

    onMouseLeaveFromPageEditor() {
      this.isPageEditorDraggeble = true;
    },
    onMouseClickInPageEditor() {
      this.isPageEditorDraggeble = false;
    },

    // async getDatabaseLinkedViewData() {
    //   if (!this.isAddingNewItem) return;
    //   if (this.element.type === 'databaselinkedview') {
    //     const databaseData = await getCustomDatabaseItems(
    //       this.element.selectedDatabaseID
    //     );
    //     const linkedElement = this.elements.find(
    //       (element) => element.name === this.element.linkedKey
    //     );

    //     if (linkedElement?.value) {
    //       const firstProp = Object?.keys(databaseData?.data?.items[0])[0];

    //       const databaseItemsToDisplay = databaseData.data.items
    //         .filter((item) => {
    //           return (
    //             (typeof item[this.element.linkedKey] === 'number' &&
    //               item[this.element.linkedKey] === linkedElement?.value) ||
    //             (typeof item[this.element.linkedKey] === 'string' &&
    //               item[this.element.linkedKey]?.toLowerCase() ===
    //                 linkedElement?.value?.toString()?.toLowerCase())
    //           );
    //         })
    //         .map((item) => {
    //           const databaseItem = {
    //             [this.element.linkedKey]: item[this.element.linkedKey],
    //             id: item.id,
    //             loading: false,
    //           };

    //           if (!databaseItem[firstProp]) {
    //             databaseItem[firstProp] = item[firstProp];
    //           }

    //           return databaseItem;
    //         });
    //       this.databaseLinkedViewData = databaseItemsToDisplay;
    //     }
    //   }
    // },
    onEditDatabaseLinkedViewData(item) {
      const domain = window.location.origin;
      const url = `${domain}/#/?section=data&database=${this.element.selectedDatabaseID}&item=${item.id}`;
      window.open(url, '_blank');
    },
    onDeleteDatabaseLinkedViewData() {
      console.log('Delete');
    },
    setRangePosition(elementID) {
      const slider = this.$refs[`rangeInput${elementID}`];
      const label = this.$refs[`rangeoutput${elementID}`];
      if (slider !== undefined && label !== undefined) {
        const position = getSliderValuePosition(slider, label);
        label.style.left = `${position}px`;
      }
    },
    onMouseLeaveFromTools() {
      this.$refs?.taskToolsMoreDropdown?.$refs?.insertNewElementDropdown?.hide(
        true
      );
    },
    setCustomValidity(e) {
      if (this.checkboxValidation === '') {
        let minValue = getCheckboxMinMax.min;
        let maxValue = getCheckboxMinMax.max;
        e.target.setCustomValidity(
          `Es müssen mindestens ${minValue} Kontrollkästchen aktiviert sein, und es können nicht mehr als ${maxValue} Kontrollkästchen aktiviert sein.`
        );
      } else {
        e.target.setCustomValidity('');
      }
    },
    onClickFreeContentElement(event) {
      if (this.isCreateCustomDB) event.stopPropagation();
    },
    onRangeInputMousedown(event) {
      if (!this.isAddingNewItem && this.isAskAiUiModalVisible)
        event.preventDefault();
    },

    onElementEdit(element) {
      if (this.isEditable && !this.isAskAiUiModalVisible) {
        this.$emit('editElement', element);
      }
    },
    getOptionsValue(value) {
      if (
        (this.element.type === 'radio' &&
          this.element.value === null &&
          ((this.isRadioButtonNotPrefilled &&
            this.preFilledRadio.includes(this.element.id)) ||
            this.createdValue !== null)) ||
        (this.element.type === 'checkbox' &&
          this.element.value.length === 0 &&
          this.createdValue !== null)
      ) {
        return false;
      }
      return value;
    },
    changeHtmlContent(e) {
      this.element.value = e.target.innerHTML;
    },
    getSanitizedContent() {
      if (!this.htmlContent) return;
      let htmlContent = this.htmlContent
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<input([^>]*)\s?\/?>/g, '<input$1 disabled />')
        .replace(/<textarea([^>]*)>/g, '<textarea$1 disabled>')
        .replace(/<select([^>]*)>/g, '<select$1 disabled>');
      return htmlContent;
    },
    onHtmlPreviewFocus() {
      this.isFocusedOnHtmlPreview = true;
    },
    onHtmlPreviewBlur() {
      this.isFocusedOnHtmlPreview = false;
    },
    filtertoogleListElements(childElement, parentElement) {
      let filter = true;
      if (
        parentElement.name.includes('start') &&
        parentElement.elements?.length
      ) {
        filter = childElement.label
          .toLowerCase()
          .includes(this.search.toLowerCase());
      }
      return (
        ((childElement.type != 'html' && childElement.type != 'model') ||
          isAdmin) &&
        filter
      );
    },
    getCheckBoxOrRadioValue(option) {
      if (this.element.type === 'radio' && this.isRadioButtonNotPrefilled) {
        return null;
      }
      return option.hasOwnProperty('value') ? option.value : option.label;
    },
    addValidationMessage(e) {
      if (
        this.element?.attributes?.pattern &&
        this.element?.attributes?.errorMessage
      ) {
        if (e.target?.validity?.patternMismatch) {
          e.target.setCustomValidity(this.element?.attributes?.errorMessage);
        } else {
          e.target.setCustomValidity('');
        }
      }
      this.handleInputValidation(e);
    },
    handleInputValidation(event) {
      showInputInvalidCustomMessage(event);
    },
    getLinkDatabseLabelValue(element) {
      if (element.value) {
        const linkedItem = this.databaseItemsList.find(
          (item) => item.id === element.value
        );
        if (
          linkedItem?.name &&
          element.selectedDatabaseType === 'loadprofile'
        ) {
          return linkedItem.name;
        } else if (linkedItem && this.showcaseField?.name) {
          return linkedItem[this.showcaseField.name] || element.value;
        }

        return element.value;
      }
      return null;
    },
    getDropDownItemLabel(item) {
      return this.element.selectedDatabaseType === 'loadprofile'
        ? item.name
        : this.showcaseField?.name
        ? item[this.showcaseField.name] || item.id
        : item.id;
    },
    formatWithThousandSeparator(value) {
      return formatWithThousandSeparator(value);
    },
    handlePointerOver(event) {
      if (!this.isAskAiUiModalVisible) return;
      let targetElement = this.getTargetedElement(event);
      if (!targetElement) {
        if (this.previousHoveredEl)
          this.previousHoveredEl.classList.remove('highlight-border');
        this.previousHoveredEl = null;
        return;
      }

      if (this.previousHoveredEl && this.previousHoveredEl !== targetElement) {
        this.previousHoveredEl.classList.remove('highlight-border');
        this.previousHoveredEl = null;
      }
      const isParentOfAttributes = targetElement.querySelector(
        '.form-builder-element-attributes'
      );
      const isInsideFormApp = targetElement.closest('.codelos-app');
      if (isParentOfAttributes && isInsideFormApp) {
        const formElement = document.getElementById('codelosForm');
        if (formElement) {
          targetElement = formElement;
        }
      }

      if (!targetElement.id) return;
      if (!targetElement.classList.contains('highlight-border'))
        targetElement.classList.add('highlight-border');
      this.previousHoveredEl = targetElement;
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'getIsAdmin',
      getDatabaseList: 'getDatabaseList',
    }),

    isSheetDatabaseType() {
      return this.selectedDatabase && this.selectedDatabase.name === 'sheet';
    },
    isLinkinView() {
      return (
        this.element.type === 'linktodb' && this.isReadOnly && !this.isEditable
      );
    },
    isDatabaseLinkedViewinView() {
      return (
        this.element.type === 'databaselinkedview' &&
        this.isReadOnly &&
        !this.isEditable
      );
    },
    isReadOnly() {
      return !this.isContentEditable || this.isAddOnly;
    },
    isLinkinEdit() {
      return (
        this.element.type === 'linktodb' &&
        this.isEditable &&
        !this.isAddingNewItem &&
        !this.isReadOnly
      );
    },

    isLinkinAdd() {
      return (
        this.element.type === 'linktodb' &&
        !this.isEditable &&
        this.isAddingNewItem &&
        !this.isReadOnly
      );
    },
    isDatabaseLinkedViewinEdit() {
      return (
        this.element.type === 'databaselinkedview' &&
        this.isEditable &&
        !this.isAddingNewItem &&
        !this.isReadOnly
      );
    },
    isDatabaseLinkedViewinAdd() {
      return (
        this.element.type === 'databaselinkedview' &&
        !this.isEditable &&
        this.isAddingNewItem &&
        !this.isReadOnly
      );
    },
    isBackgroundImage() {
      return this.element.attributes.isImgShowInBackGround;
    },
    isShowDescription() {
      return this.element.attributes.isShowTitleAndDescription;
    },
    getFormatNumber() {
      if (this.element.type === 'formatted_number') {
        return {
          thousandseparator: this.element?.settings?.thSep ?? '.',
          decimalseparator: this.element?.settings?.decSep ?? ',',
        };
      } else return null;
    },
    isNotSelectOrCardElement() {
      return (
        !this.isChoiceWithCard(this.element) &&
        !this.isBackgroundImage &&
        !this.isShowDescription &&
        this.element.type !== 'select'
      );
    },
    isSelectedOptionLabel() {
      if (this.element.value != null && this.element.value != '') {
        return this.element.options.find(
          (option) => option.value === this.element.value
        )?.label;
      } else return 'wähle eine Option';
    },
    getDatabaseLinkedViewDropdownOptions() {
      return this.elements
        ?.filter((schemaItem) => ['text', 'number'].includes(schemaItem.type))
        ?.map((schemaItem) => ({
          label: schemaItem.label,
          name: schemaItem.name,
        }));
    },
    isRangeInput() {
      return this.element.type === 'range' ? this.element : null;
    },
    // getDatabaseLinkedViewDataHeaders() {
    //   if (this.databaseLinkedViewData && this.databaseLinkedViewData.length) {
    //     const headerElements = Object?.keys?.(this.databaseLinkedViewData[0]);
    //     if (headerElements.length > 2) {
    //       const indexOfId = headerElements.indexOf('id');
    //       headerElements.splice(indexOfId, 1);
    //       const indexOfLoading = headerElements.indexOf('loading');
    //       headerElements.splice(indexOfLoading, 1);
    //     }
    //     return headerElements;
    //   }
    //   return [];
    // },
    checkboxValidation() {
      const minValue = getCheckboxMinMax.min;
      const maxValue = getCheckboxMinMax.max;
      const totalChecked = this.element.options.filter(
        (option) => option.checked
      ).length;
      if (totalChecked < minValue || totalChecked > maxValue) {
        return '';
      } else {
        return '90';
      }
    },
    getCheckBoxElementMinMax() {
      const minValue =
        this.element.settings.min !== '' ||
        this.element.settings.min !== undefined
          ? this.element.settings.min
          : 1;
      const maxValue =
        this.element.settings.max !== '' ||
        this.element.settings.max !== undefined
          ? this.element.settings.max
          : this.element.options.length;
      return {
        minValue,
        maxValue,
      };
    },
    checkboxValidationRequired() {
      return (
        this.hasFooter &&
        this.element.type === 'checkbox' &&
        this.element.attributes.required &&
        !this.element.attributes.disabled
      );
    },
    getSliderElementValue() {
      return this.element.value === null || this.element.value === undefined
        ? Math.floor(
            (Number(this.element.attributes.max) +
              Number(this.element.attributes.min)) /
              2
          )
        : this.element.value;
    },
    getPattern() {
      if (this.element?.attributes?.pattern) {
        return `${this.element.attributes.pattern}`;
      }
      return null;
    },
    isRadioButtonNotPrefilled() {
      return this.element?.attributes?.prefilled === false;
    },
    isActivePropsElement() {
      return (
        this.isPropsModalVisible &&
        this.element?.id === this.selectedElement?.id &&
        this.element?.name === this.selectedElement?.name
      );
    },
    isInputRequired() {
      if (this.element.type === 'radio') {
        return this.element?.attributes?.required;
      }
      return false;
    },
    isShowTextAreaHtmlViewSwitch() {
      const htmlPattern = /<\/?[a-z][\s\S]*>/i;
      return (
        this.isAddingNewItem &&
        this.element.type === 'textarea' &&
        htmlPattern.test(this.element.value)
      );
    },
  },
  watch: {
    isRangeInput: {
      handler(element) {
        if (element && element.type === 'range' && element.id) {
          setTimeout(() => {
            this.setRangePosition(element.id);
          }, 0);
        }
      },
      deep: true,
      immediate: true,
    },
    'element.attributes.prefilled': {
      handler(newval, _oldval) {
        if (newval) {
          this.preFilledRadio = this.preFilledRadio.filter(
            (value) => value !== this.element.id
          );
        } else {
          this.preFilledRadio.push(this.element.id);
        }
      },
    },
    'element.value': {
      handler() {
        if (this.element.type === 'html' && !this.isFocusedOnHtmlPreview) {
          this.htmlContent = this.element.value;
        }
      },
    },
  },
  components: {
    Cards: () => import('../widgets/cards.vue'),
    FilePicker,
    GeneralDropdown,
    NumberComponent,
    PageEditor,
    CustomDatabaseInline,
    TableSkeleton,
    CommonSwitch,
  },
};
</script>

<style scoped>
.modal.task .form-group .tools {
  height: 100%;
  left: 2px;
  top: 6px;
  cursor: pointer;
  display: inline;
  width: 6%;
  opacity: 0;
  -webkit-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

.modal.task .form-group:hover .tools {
  opacity: 1;
}

input,
select {
  font-family: 'Open Sans', open-sans, sans-serif;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  margin-right: 10px;
  margin-bottom: 15px;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: 300;
}

select {
  width: 100%;
}

textarea {
  resize: none;
  background: #fff;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  padding: 8px 12px;
  min-height: 140px;
}

/* input:disabled,
textarea:disabled,
select:disabled {
  border: none !important;
} */

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
  cursor: pointer;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}
p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}
.togglelist-label {
  font-weight: 500;
  font-size: 12px;
  color: #7e8890;
  margin: 12px 0px 12px 11px;
}

.wizard-title h3 {
  color: #5f697a;
  text-transform: capitalize;
  font-weight: 500;
  display: flex;
  align-items: center;
  font-size: 22px;
}

.form-input {
  cursor: text;
}

.form-input.highlighted {
  background: #ff000024;
  padding: 5px;
}

.form-elements .tools {
  float: right;
  width: 32px;
  height: 30px;
  margin-top: -41px;
}
.form-elements .tools i {
  font-size: 18px;
}
.form-elements .edit-overlay {
  top: 0;
  width: 94%;
  height: 100%;
  -webkit-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
  cursor: unset;
  background: rgb(222 225 231 / 88%);
  opacity: 0;
  position: absolute;
  display: block;
  left: 0;
  border-radius: 6px;
  cursor: pointer;
}

.form-elements .edit-overlay:hover {
  opacity: 0.5;
}

.form-elements .drop-zone.horizontal {
  width: 100%;
}

.form-elements .drop-zone.vertical {
  float: right;
  position: relative;
}

.form-elements .element-label {
  margin-top: 12px;
}
.form-container label {
  width: 80%;
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  margin: 0px 10px 6px 12px;
  color: #464d5d;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
}

button {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 17px;
  margin-bottom: 20px;
  margin-right: 30px;
}
.form-elements input,
.form-elements select {
  border-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  width: 95%;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 35px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 12px 11px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.radio-wrapper {
  width: 100%;
  display: block;
  margin-top: 4px;
}

.radioOption {
  display: inline-flex;
  height: auto;
  margin-right: 22px;
  align-items: center;
}

.radioOption label {
  line-height: 21px;
  padding: 0;
  margin-bottom: 0;
  margin-right: 0;
  width: auto;
  margin-left: 12px;
}

.radioOption input {
  float: none;
  width: 20px;
  margin-bottom: 0;
}

h3.codelos-title {
  /* color: #5f697a;
  font-size: 1.17em;
  font-weight: bold; */
  color: #5f697a;
  font-weight: 500;
  border-left: 2px solid #5f697a;
  padding-left: 10px;
  display: flex;
  align-items: center;
  font-size: 22px;
}
img.preview-image {
  width: 50%;
  margin: 10px auto;
  display: block;
}
.required-url {
  font-size: 14px;
  color: red;
  background: rgba(236, 237, 240, 0.88);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  margin-left: 11px;
  margin: 0;
  width: 100%;
}

.togglelist-label:hover {
  text-decoration: underline;
  cursor: pointer;
}

.edit-item-name ::v-deep .dropped-file-wrap .dropped-file-name {
  width: 100%;
  margin: 0;
}

.edit-item-name {
  width: 100%;
}

.edit-item-name ::v-deep .no-file-selected {
  width: 100%;
  margin: 0;
}
.update-select-file ::v-deep .file-selected {
  width: 100%;
}

.edit-item-name.update-select-file {
  margin-left: 0;
}
/* .content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
} */

/*New Formbuilder elements*/
.form-builder-elements,
.form-builder-elements * {
  box-sizing: border-box;
}

.form-builder-elements .form-builder-element-attributes .element-label {
  margin: 0 0 6px;
  width: 100%;
  font-weight: 300;
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  color: #464d5d;
  font-size: 14px;
}

.form-builder-elements .form-builder-element-attributes .form-input,
.form-builder-elements
  .form-builder-element-attributes
  .input-attribute
  ::v-deep
  .number-input {
  margin: 0 0 0;
  width: 100%;
  padding: 8px 12px;
  height: auto;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  box-shadow: none;
  background: #fff;
}

.form-builder-elements
  .form-builder-element-attributes
  .form-input.prevent-pointer-event,
.form-builder-elements
  .form-builder-element-attributes
  .input-attribute
  ::v-deep
  .number-component.prevent-pointer-event
  .number-input,
.form-builder-elements
  .form-builder-element-attributes
  .form-textarea.prevent-pointer-event {
  pointer-events: none;
}

.form-builder-elements .form-builder-element-attributes input[type='range'] {
  padding: 0;
}

.form-builder-elements .form-builder-element-attributes .input-attribute {
  display: flex;
  flex-direction: column;
}
.form-builder-elements
  .form-builder-element-attributes
  .input-attribute
  .element-label
  .required-tick {
  color: red !important;
  padding: 0 3px;
}
.form-builder-elements .form-builder-element-attributes {
  padding: 12px;
  margin-bottom: 0;
  border-radius: 6px;
  transition: all 300ms ease-in-out;
  position: relative;
  z-index: 0;
}
.edit-mode.form-builder-elements .ai-model-active {
  z-index: 1;
}
.form-builder-elements .form-builder-element-attributes:before {
  content: '';
  background: rgba(222, 225, 231, 0.88);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  opacity: 0;
  visibility: hidden;
  transition: all 300ms ease-in-out;
  z-index: -1;
}

.edit-mode.form-builder-elements .form-builder-element-attributes:hover:before {
  opacity: 0.5;
  visibility: visible;
}

.edit-mode.form-builder-elements .ai-model-active:hover:before {
  z-index: -1;
}
.form-builder-element-wrap {
  position: relative;
  max-width: 75%;
  margin: 0 auto;
}
.form-builder-element-wrap.full-width {
  max-width: 100% !important;
}
.form-builder-elements .edit-mode-tools i {
  color: rgb(159, 159, 159);
}

.edit-mode .edit-mode-tools {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  padding-left: 4px;
  opacity: 0;
  visibility: hidden;
  transition: all 300ms ease-in-out;
  z-index: 1;
}

.edit-mode .form-builder-element-wrap:hover .edit-mode-tools {
  opacity: 1;
  visibility: visible;
}

.edit-mode .edit-mode-tools i {
  font-size: 18px;
  margin: 0;
}

.edit-mode .edit-mode-tools li {
  cursor: pointer;
}

.start-form-builder .workBuilder-element-width.form-builder-element-wrap {
  max-width: 60%;
}
.nested-form-elements .form-builder-element-wrap {
  max-width: 100%;
}

.drop-zone.top {
  border-top: 5px solid #86c3f4;
}

.drop-zone.bottom {
  border-bottom: 5px solid #86c3f4;
}

.form-builder-element-wrap .link-to-db-wrapper-edit {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
}

.form-builder-element-wrap .link-to-db-wrapper-edit a {
  text-decoration: underline;
  color: black;
}

.form-builder-element-wrap .link-to-db-wrapper-edit i {
  margin-right: 5px;
  font-size: 14px;
}

.form-builder-element-wrap .link-to-db-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.form-builder-element-wrap .link-to-db-wrapper i {
  margin-right: 5px;
  font-size: 14px;
}

.form-builder-element-wrap .input-attribute .linktodb-edit-icon {
  cursor: pointer;
  font-size: 14px;
}

.form-builder-element-wrap .database-dropdown ::v-deep .customDropdown {
  width: 100% !important;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  height: 37px;
  color: #464d5d;
  justify-content: space-between;
  padding: 0px 15px 0px 15px;
}

.form-builder-element-wrap ::v-deep .database-dropdown {
  width: 100%;
  background: #fff;
}
.form-builder-element-wrap ::v-deep .database-dropdown .dropdown-menu {
  width: 100%;
}

.form-builder-element-wrap
  .link-to-db-dropdown
  .database-dropdown
  ::v-deep
  .btn
  a {
  text-decoration: underline;
  color: black;
}

.form-builder-elements
  .form-builder-element-wrap
  .link-to-db-dropdown
  .database-dropdown
  ::v-deep
  .selected
  a {
  background: #f0f0f0 !important;
}

.form-builder-element-wrap
  .link-to-db-dropdown
  .database-dropdown
  ::v-deep
  .loading-overlay-wrapper {
  height: 40px;
}

.form-builder-element-wrap .link-to-db-dropdown .loading-overlay {
  position: absolute;
  background: transparent;
  width: 100%;
  z-index: 1;
  top: 0;
  text-align: center;
  height: 100%;
  border-radius: 4px;
}
.form-builder-element-wrap
  .link-to-db-dropdown
  .loading-overlay
  .progress-icon {
  content: ' ';
  display: block;
  width: 25px;
  height: 25px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #1f2532c7;
  border-color: #1f2532c7 transparent #1f2532c7 transparent;
  animation: progress-icon 1.2s linear infinite;
  margin: 0 auto;
  top: 5px;
  position: absolute;
  left: 44%;
}

/*end*/

.image-section-radio {
  display: inline-block;
  width: 300px;
  height: 200px;
  margin-right: 20px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.image-section-radio input {
  opacity: 0;
  position: absolute;
}
.image-section-radio input:checked + label {
  border-color: #000;
}
.image-section-radio label {
  margin: 0;
  display: block;
  width: 100%;
  height: 100%;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 15px;
}
.image-section-radio label .title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  position: relative;
  z-index: 1;
}
.image-with-detail-wrap.radio-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.form-builder-elements .image-with-detail-wrap .image-with-detail-section {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 20px;
  border: 1px solid rgb(221, 221, 221);
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-shadow: none;
  border-radius: 15px;
  min-height: 122px;
  min-width: 168px;
  background-position: center center;
  background-size: cover;
  position: relative;
  overflow: hidden;
  background: #fff;
}

.form-builder-elements
  .show-background.image-with-detail-wrap
  .image-with-detail-section {
  min-width: 370px;
  min-height: 215px;
}
.form-builder-elements
  .show-description.image-with-detail-wrap
  .image-with-detail-section {
  width: 370px;
  min-height: 260px;
}
.form-builder-elements
  .show-background.image-with-detail-wrap
  .image-with-detail-section
  label
  .title {
  font-size: 30px;
  font-weight: 600;
}

.image-with-detail-wrap .image-with-detail-section input {
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.image-with-detail-wrap .image-with-detail-section input:checked .option-label {
  border-color: #000;
}

.image-with-detail-wrap .image-with-detail-section label {
  /* color: inherit; */
}
.image-with-detail-wrap .image-with-detail-section .option-label {
  width: 100% !important;
  margin: 0 !important;
  padding: 0;
  border: 1px solid transparent;
  cursor: pointer;
  /* color: inherit; */
}

.form-builder-elements
  .show-description.image-with-detail-wrap
  .image-with-detail-section
  .option-image {
  text-align: center;
}
.form-builder-elements
  .image-with-detail-wrap
  .image-with-detail-section
  .option-image {
  width: fit-content;
}

.option-image img {
  max-width: 100%;
  width: 34px;
  margin-bottom: 39px;
}
.form-builder-elements
  .image-with-detail-wrap
  .image-with-detail-section
  .detail {
  margin-top: 39px;
}
.form-builder-elements
  .show-description.image-with-detail-wrap
  .option-image
  img {
  width: auto;
  height: 230px;
}

.form-builder-elements
  .image-with-detail-wrap
  .image-with-detail-section
  label
  .title {
  font-size: 15px;
  display: block;
  float: none;
  color: #5f697a;
  margin: 0;
  padding: 0 0;
  line-height: normal;
}
.form-builder-elements
  .show-description.image-with-detail-wrap
  .image-with-detail-section
  label
  .title {
  font-size: 30px;
  font-weight: 600;
  font-family: 'Open Sans', open-sans, sans-serif;
  color: #5f697a;
}
.form-builder-elements
  .image-with-detail-wrap.both-image-description-active
  .image-with-detail-section
  label {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.form-builder-elements .both-image-description-active .detail {
  padding: 10px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  word-wrap: break-word;
  margin-top: 60px !important;
}
.form-builder-elements
  .show-background.image-with-detail-wrap
  .image-with-detail-section
  h1,
.form-builder-elements
  .image-with-detail-wrap
  .image-with-detail-section
  label
  h1 {
  font-size: 2em;
}
.form-builder-elements
  .image-with-detail-wrap
  .image-with-detail-section-active {
  border: 2px solid rgb(21 21 21);
}
.form-builder-elements
  .image-with-detail-wrap
  .image-with-detail-section-inactive:hover {
  border: 1.4px solid rgb(21 21 21);
}
.image-with-detail-wrap .image-with-detail-section > label {
  padding: 20px;
  width: 100% !important;
  margin: 0 !important;
  border: 1px solid transparent;
  cursor: pointer;
  height: 100%;
}

.form-builder-elements .database-linked-view table,
.form-builder-elements .database-linked-view tr,
.form-builder-elements .database-linked-view td,
.form-builder-elements .database-linked-view th {
  border: 1px solid black;
}
.form-builder-elements .database-linked-view td,
.form-builder-elements .database-linked-view th {
  height: 40px;
  min-width: 100px;
}

.form-builder-elements .tools-action-wrapper i {
  cursor: pointer;
}
.form-builder-element-attributes-label ::v-deep .dropdown-toggle {
  background: transparent;
  color: #464d5d;
  border: none;
  text-align: left;
  padding: 0;
  font-size: 14px;
}
.form-builder-element-attributes-label ::v-deep .dropdown-menu {
  left: 10px !important;
}

.form-builder-element-attributes-label {
  margin: 0 !important;
}

.form-builder-element-attributes-label ::v-deep .dropdown-toggle::after {
  content: none;
}
.form-builder-element-attributes-label ::v-deep * {
  cursor: auto !important;
}
.form-builder-element-attributes-label ::v-deep button,
.form-builder-element-attributes-label ::v-deep button span {
  cursor: pointer !important;
}

.ai-dropdown-wrap input[type='text'] {
  margin: 0;
  padding: 0;
  border: none;
  width: 100%;
  padding: 10px;
}

.ai-dropdown-wrap input[type='text']::placeholder {
  opacity: 0.7;
  font-size: 14px;
}

.ai-dropdown-wrap .submit-btn {
  width: auto;
  padding: 9px 20px !important;
  height: auto;
  min-width: 100px;
  margin: 20px 0 0 0;
  float: right;
  transform: translateY(0) scale(1.001);
  background-color: #000;
  display: inline-block;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  white-space: pre;
  font-size: 0.9375rem;
  color: #fff;
  border: 3px solid #000;
  border-radius: 0.375em;
  text-transform: none;
}
::v-deep .form-builder-element-attributes-label {
  position: absolute;
  z-index: 100000;
}

::v-deep .dropdown-menu {
  min-width: 310px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
  border: none;
  padding: 15px;
}
.ai-dropdown-wrap .custom-table-progress-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  border-color: #ffffff transparent #ffffff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
}
@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ai-dropdown-wrap .error {
  color: red;
  font-size: 12px;
  margin-top: 10px;
  display: inline-block;
}
.form-builder-elements input:focus-visible {
  outline: none !important;
}
::v-deep .form-builder-elements .number-component input:focus-visible {
  outline: none !important;
}
::v-deep .form-builder-elements .input-attribute textarea:focus-visible {
  outline: none !important;
}

.form-builder-element-wrap ::v-deep .database-dropdown.display-dropdown {
  width: 100%;
  position: relative;
  z-index: auto !important;
}
.form-builder-elements .range-slider-values {
  display: flex;
  justify-content: space-between;
  padding: 10px 2px;
  font-size: 14px;
  line-height: 16.55px;
  color: #5f5f5f;
}

.form-builder-elements .range-output-value {
  position: absolute;
  left: 0;
  top: 98px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  color: #5f5f5f;
  min-width: 36px;
  height: 18px;
  border-radius: 6px;
  border: 0.5px solid #bdbdbd;
  text-align: center;
  color: #000;
  background: #fff;
}

.form-builder-elements .range-input {
  margin-bottom: 21px !important;
}

.form-builder-element-wrap
  .edit-mode-tools
  .task-tools-more-dropdown
  ::v-deep
  button {
  margin-left: 5px;
  box-shadow: none;
}

.form-builder-element-wrap .edit-mode-tools ::v-deep .dropdown-menu {
  padding: 8px;
  min-width: 0px;
}
.form-builder-element-wrap ::v-deep .task-tools-more-dropdown {
  display: flex;
  z-index: 10;
}
.form-builder-element-wrap .checkBox-validation {
  width: 0px;
  height: 0px;
  margin: 0px !important;
  padding: 0px !important;
  position: absolute;
  bottom: 23px;
}

.form-builder-element-wrap .cursor-pointer {
  cursor: pointer;
}

.form-builder-elements .html-render {
  padding: 0 12px;
}

.form-builder-elements .form-builder-element-attributes.active {
  background-color: rgba(222, 225, 231, 0.5);
}

.form-builder-elements.edit-mode
  .form-builder-element-attributes.active:hover:before {
  opacity: 0;
}
.skeleton-wrapper {
  max-width: 75%;
  padding: 12px;
  margin: 0 auto;
}
.skeleton-wrapper ::v-deep .skeleton-table td div {
  padding: 30px;
}
.form-builder-elements .ai-model-active ::v-deep .highlight-border,
.form-builder-elements .ai-model-active ::v-deep .ai-target-element {
  outline: 2px solid #ff3366 !important;
  outline-offset: 0px !important;
}
.form-builder-elements .html-render [contenteditable] {
  outline: none;
}
.form-builder-elements .html-render {
  border: 1px solid #dee3e9;
  background: #ffffff;
  padding: 10px;
  border-radius: 2px;
  color: #898e9a;
}
.form-builder-elements .html-view-switch {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  padding: 5px 0;
}
.form-builder-elements .html-view-switch span {
  font-weight: 300;
  font-family: 'Open Sans', open-sans, sans-serif;
  color: #464d5d;
  font-size: 14px;
}
.form-builder-elements .textarea-html-render {
  border: 1px solid #dee3e9;
  background: #ffffff;
  padding: 12px;
  border-radius: 2px;
  min-height: 140px;
}
</style>
